Math.clip = (number, min, max) => Math.max(min, Math.min(number, max)); // https://stackoverflow.com/a/11409978
